import { CalendarCheck } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { ReservationRoutes } from "./routes";
import { ReservationPermissions } from "./permissions";

export const reservationNav: INavItem = {
  labelKey: "nav.reservations",
  icon: CalendarCheck,
  path: ReservationRoutes.LIST,
  permissions: [ReservationPermissions.READ],
};
